import { withChildren } from '@builder.io/react';
import { Builder } from '@builder.io/react';
import React from 'react';

import TooltipComponent, {
  TooltipProps,
} from '../../storyblocks-design-system/components/atoms/Tooltip/Tooltip';

interface TooltipBuilderProps extends TooltipProps {
  side?: 'left' | 'right' | 'top' | 'bottom';
}

const Tooltip = withChildren(
  ({
    children,
    title,
    description,
    variant,
    hasArrow,
    side,
    defaultOpen,
  }: TooltipBuilderProps) => {
    return (
      <TooltipComponent
        title={title}
        description={description}
        trigger={
          <div className="inline-block" role="button" tabIndex={0}>
            {children}
          </div>
        }
        variant={variant}
        hasArrow={hasArrow}
        defaultOpen={defaultOpen}
        contentProps={{ side }}
      />
    );
  }
);

Builder.registerComponent(Tooltip, {
  name: 'Tooltip',
  inputs: [
    {
      name: 'title',
      type: 'string',
      defaultValue: '',
    },
    {
      name: 'description',
      type: 'richText',
      defaultValue: '',
    },
    {
      name: 'variant',
      type: 'string',
      defaultValue: 'dark',
      enum: [
        {
          label: 'Dark',
          value: 'dark',
        },
        {
          label: 'Light',
          value: 'light',
        },
      ],
    },
    {
      name: 'hasArrow',
      type: 'boolean',
      defaultValue: true,
    },
    {
      name: 'side',
      type: 'string',
      defaultValue: 'top',
      enum: [
        {
          label: 'Top',
          value: 'top',
        },
        {
          label: 'Left',
          value: 'left',
        },
        {
          label: 'Right',
          value: 'right',
        },
        {
          label: 'Bottom',
          value: 'bottom',
        },
      ],
    },
    {
      name: 'defaultOpen',
      type: 'boolean',
      defaultValue: false,
      enum: [
        {
          label: 'Yes',
          value: true,
        },
        {
          label: 'No',
          value: false,
        },
      ],
    },
  ],
  defaultChildren: [
    {
      '@type': '@builder.io/sdk:Element',
      component: { name: 'Text', options: { text: 'Your content here.' } },
    },
  ],
});
